var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('local-home-top-statement'),_vm._v(" "),_c('local-home-sections-light'),_vm._v(" "),_c('local-home-bottom-statement'),_vm._v(" "),_c('v-container',[_c('local-home-process')],1),_c('v-divider'),_c('local-home-thankyou')],1)}
var staticRenderFns = []

export { render, staticRenderFns }